document.addEventListener('DOMContentLoaded', function () {
	if (window.innerWidth > 768) {
		var cursor = document.querySelector('.cursor');
		var follower = document.querySelector('.cursor-follower');

		// Déclarée ici, et non plus au milieu du fichier : animate() part dès
		// la ligne suivante, bien avant l'ancien point de déclaration. La lire
		// plus bas revenait à lire undefined au premier tour de boucle.
		var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

		var posX = 0,
			posY = 0,
			mouseX = 0,
			mouseY = 0,
			scrollX = 0,
			scrollY = 0;

		function animate() {
			// En tête de frame, donc AVANT les écritures de style plus bas : lire
			// la mise en page après l'avoir modifiée dans la même frame forcerait
			// un recalcul synchrone, ce que ce découpage évite.
			if (besoinReleve && cibles) {
				besoinReleve = false;
				releverCible();
			}
			// Mouvement réduit : suivi direct, sans traînée. Hors réglage
			// système, k vaut 9 comme avant : le curseur ne bouge pas d'un pixel.
			var k = reduceMotion.matches ? 1 : 9;
			posX += (mouseX - posX) / k;
			posY += (mouseY - posY) / k;

			follower.style.left = posX + scrollX - 24 + 'px';
			follower.style.top = posY + scrollY - 24 + 'px';

			cursor.style.left = mouseX + scrollX - 4 + 'px';
			cursor.style.top = mouseY + scrollY - 4 + 'px';

			requestAnimationFrame(animate);
		}
		animate();

		// UN SEUL ÉCOUTEUR DE POINTEUR, ET AUCUN RELEVÉ DEDANS.
		// Il y en avait quatre : deux pour les coordonnées, deux qui appelaient
		// document.elementFromPoint pour savoir ce qu'il y a sous le curseur.
		// elementFromPoint force le navigateur à recalculer la mise en page avant
		// de répondre : à deux appels par mouvement de souris, sur toutes les
		// pages du site, c'était la première source de saccade au survol.
		// Ici on ne fait qu'enregistrer la position et lever un drapeau ; le
		// relevé se fait une fois par frame dans animate(), qui tourne déjà.
		/* LE POINTEUR PEUT SORTIR DE NOTRE DOCUMENT.
		   Une iframe est un autre document : des que le pointeur y entre, plus
		   aucun mouvement ne remonte ici et les deux marqueurs restent figes a
		   la frontiere. On les efface en fondu dans ce cas, plutot que de
		   laisser un curseur plante que l'oeil lit comme un bug.

		   Trois signaux, parce qu'aucun ne suffit seul :
		     · pointerover sur un IFRAME — l'entree dans le cadre ;
		     · window.blur — le clic a donne le focus au document interne, ce
		       qui n'emet aucun pointerover ;
		     · pointermove sur notre document — le retour, quel qu'ait ete le
		       chemin de sortie. C'est lui qui rend le mecanisme auto-reparant :
		       meme si une sortie nous echappe, le premier mouvement reel chez
		       nous rallume les marqueurs.
		   La delegation sur document couvre les iframes ajoutees plus tard,
		   comme le lecteur 3D de la fiche merch, monte au clic. */
		function horsContexte(oui) {
			cursor.classList.toggle('hors-contexte', oui);
			follower.classList.toggle('hors-contexte', oui);
		}
		document.addEventListener('pointerover', function (e) {
			if (e.target && e.target.tagName === 'IFRAME') horsContexte(true);
		}, true);
		window.addEventListener('blur', function () {
			if (document.activeElement && document.activeElement.tagName === 'IFRAME') {
				horsContexte(true);
			}
		});
		document.addEventListener('pointermove', function (e) {
			if (!e.target || e.target.tagName !== 'IFRAME') horsContexte(false);
		}, true);

		var clientX = 0, clientY = 0;
		var besoinReleve = false;

		document.addEventListener('mousemove', function (e) {
			mouseX = e.pageX - scrollX;
			mouseY = e.pageY - scrollY;
			clientX = e.clientX;
			clientY = e.clientY;
			besoinReleve = true;
		}, { passive: true });

		// Le défilement déplace les cartes sous un curseur immobile : il faut
		// donc refaire le relevé. Mais l'écouteur lui-même reste vide de tout
		// calcul, et il est passif : sans ce drapeau, le navigateur devait
		// attendre la fin du handler avant de faire défiler la page.
		function onScroll() {
			scrollX = window.scrollX;
			scrollY = window.scrollY;
			besoinReleve = true;
		}

		window.addEventListener('scroll', onScroll, { passive: true });

		// Y a-t-il seulement quelque chose à survoler sur cette page ? Les pages
		// légales, contact ou article n'ont ni carte ni ligne d'offre : elles ne
		// paient alors plus aucun relevé. Réévalué quand l'éditeur de thème
		// recharge une section.
		var cibles = false;
		function majCibles() {
			cibles = !!document.querySelector('[data-cursor-label], .mm-offres-row[data-cursor-text]');
		}
		majCibles();
		document.addEventListener('shopify:section:load', majCibles);

		// Le relevé unique : un seul elementFromPoint sert à la fois les cartes
		// et les lignes d'offre, là où deux écouteurs en faisaient chacun un.
		function releverCible() {
			var el = document.elementFromPoint(clientX, clientY);

			var card = el && el.closest('[data-cursor-label]');
			if (card && !isOverGridCard) {
				isOverGridCard = true;
				showGridCTA(card);
			} else if (card && isOverGridCard) {
				updateGridCTA(card);
			} else if (!card && isOverGridCard) {
				isOverGridCard = false;
				hideGridCTA();
			}

			var row = el && el.closest('.mm-offres-row');
			var rowHasCta = row && row.hasAttribute('data-cursor-text') && row.hasAttribute('data-cursor-link');
			if (rowHasCta && !isOverOffreRow) {
				isOverOffreRow = true;
				showOffresCTA(row);
			} else if (rowHasCta && isOverOffreRow) {
				var text = row.getAttribute('data-cursor-text');
				if (follower.getAttribute('data-cta-text') !== text) {
					showOffresCTA(row);
				}
			} else if ((!row || !rowHasCta) && isOverOffreRow) {
				isOverOffreRow = false;
				hideOffresCTA();
			}
		}


		var projects = document.querySelectorAll('.mm-projets-project');
		projects.forEach(function (project) {
			project.addEventListener('mouseenter', function () {
				cursor.classList.add('active');
				follower.classList.add('active');
			});

			project.addEventListener('mouseleave', function () {
				cursor.classList.remove('active');
				follower.classList.remove('active');
			});
		});

		// New masonry grid project cards — CTA follows on the follower element
		var gridHideTimeout = null;
		var isOverGridCard = false;

		// data-cursor-label et non une classe de section : l'etiquette suit
		// l'intention, pas l'emplacement. Toute carte qui en porte une la
		// recoit, d'ou qu'elle vienne. Le libelle est lu ici et plus par un
		// gestionnaire inline defini dans la section de l'accueil : ailleurs,
		// cette fonction n'existait pas et l'etiquette tombait sur son defaut.
		var currentGridLabel = null;
		var labelSwapTimeout = null;

		function setGridLabel(text) {
			// Le libelle devient un contenu CSS entre guillemets : on protege
			// les caracteres qui fermeraient la chaine.
			var safe = String(text).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
			follower.style.setProperty('--cursor-label', '"' + safe + '"');
			currentGridLabel = text;
		}

		function showGridCTA(card) {
			if (labelSwapTimeout) { clearTimeout(labelSwapTimeout); labelSwapTimeout = null; }
			follower.classList.remove('label-swap-out', 'label-swap-in');
			if (card && card.dataset && card.dataset.cursorLabel) {
				setGridLabel(card.dataset.cursorLabel);
			}
			if (gridHideTimeout) { clearTimeout(gridHideTimeout); gridHideTimeout = null; }
			follower.classList.remove('active-grid-out');
			cursor.classList.add('active-grid-hidden');
			follower.classList.add('active-grid');
		}

		// Le curseur passe d'une carte a l'autre sans quitter la grille :
		// l'etat "au-dessus" ne bouge pas, mais le libelle, si. L'ancien sort
		// par le haut, le nouveau entre par le bas — le roulement vit dans
		// assets/mm-cursor-cta.css (.label-swap-out / .label-swap-in), seul le
		// texte roule, le carre noir reste en place. Un passage rapide sur une
		// troisieme carte repart du debut : le timer est rearme et c'est
		// toujours le dernier libelle vise qui s'installe.
		function updateGridCTA(card) {
			var text = card && card.dataset ? card.dataset.cursorLabel : null;
			if (!text || text === currentGridLabel) return;
			if (reduceMotion.matches) {
				setGridLabel(text);
				return;
			}
			if (labelSwapTimeout) clearTimeout(labelSwapTimeout);
			follower.classList.remove('label-swap-in');
			follower.classList.add('label-swap-out');
			labelSwapTimeout = setTimeout(function () {
				setGridLabel(text);
				follower.classList.remove('label-swap-out');
				follower.classList.add('label-swap-in');
				labelSwapTimeout = setTimeout(function () {
					follower.classList.remove('label-swap-in');
					labelSwapTimeout = null;
				}, 220);
			}, 140);
		}

		function hideGridCTA() {
			if (gridHideTimeout) return;
			if (labelSwapTimeout) { clearTimeout(labelSwapTimeout); labelSwapTimeout = null; }
			follower.classList.remove('label-swap-out', 'label-swap-in');
			follower.style.removeProperty('--cursor-label');
			currentGridLabel = null;
			cursor.classList.remove('active-grid-hidden');
			follower.classList.add('active-grid-out');
			gridHideTimeout = setTimeout(function () {
				follower.classList.remove('active-grid', 'active-grid-out');
				gridHideTimeout = null;
			}, 200);
		}

		// (le survol des cartes est relevé par releverCible(), une fois par frame)

		// Offres rows — CTA follows cursor with dynamic text
		var offresHideTimeout = null;
		var isOverOffreRow = false;

		function showOffresCTA(row) {
			if (offresHideTimeout) { clearTimeout(offresHideTimeout); offresHideTimeout = null; }
			var text = row.getAttribute('data-cursor-text') || 'Découvrir';
			follower.setAttribute('data-cta-text', text);
			follower.classList.remove('active-offres-out');
			cursor.classList.add('active-grid-hidden');
			follower.classList.add('active-offres');
		}
		function hideOffresCTA() {
			if (offresHideTimeout) return;
			cursor.classList.remove('active-grid-hidden');
			follower.classList.add('active-offres-out');
			offresHideTimeout = setTimeout(function () {
				follower.classList.remove('active-offres', 'active-offres-out');
				follower.removeAttribute('data-cta-text');
				offresHideTimeout = null;
			}, 200);
		}

		// (idem pour les lignes d'offre)

		// Click handler for offres rows
		document.addEventListener('click', function (e) {
			var row = e.target.closest('.mm-offres-row');
			if (row) {
				var link = row.getAttribute('data-cursor-link');
				if (link) window.location.href = link;
			}
		});

		var blackSections = document.querySelectorAll('.mm-wrapper-black, .mm-projets-grid-section, .mm-section-offres');
		blackSections.forEach(function (blackSection) {
			blackSection.addEventListener('mouseover', function () {
				cursor.classList.add('primary');
				follower.classList.add('primary');
			});

			blackSection.addEventListener('mouseleave', function () {
				cursor.classList.remove('primary');
				follower.classList.remove('primary');
			});
		});

		var contactForm = document.querySelector('.mm-contact-iframe');
		if (contactForm) {
			contactForm.addEventListener('mouseover', function () {
				cursor.style.display = 'none';
				follower.style.display = 'none';
			});

			contactForm.addEventListener('mouseleave', function () {
				cursor.style.display = 'block';
				follower.style.display = 'block';
			});
		}

	}
});

/* ===========================================================================
   LIENS EXTERNES — nouvel onglet, impérativement.
   ---------------------------------------------------------------------------
   Règle éditoriale du site : tout lien qui quitte le site s'ouvre dans un
   nouvel onglet. Posée ici en JS et non dans les gabarits, parce que les
   liens saisis dans les champs richtext de l'éditeur ne peuvent pas porter
   target (Shopify n'y autorise que href) — c'est le seul endroit qui couvre
   tout, y compris les contenus que le BO saisira demain.

   Est interne : le domaine courant, moon-moon.fr et ses sous-domaines, et
   les environnements myshopify du store. Tout le reste part en _blank avec
   noopener (les rel existants sont conservés).

   La règle vaut dans les deux sens : un lien INTERNE qui porte un _blank
   posé en dur (vieux contenus saisis dans l'admin) le perd — la navigation
   du site reste dans l'onglet, toujours.
   =========================================================================== */
(function () {
	'use strict';

	if (window.__mmLiensExternes) return;
	window.__mmLiensExternes = true;

	function interne(host) {
		return host === location.host ||
			host === 'moon-moon.fr' || host.endsWith('.moon-moon.fr') ||
			host.endsWith('.myshopify.com');
	}

	function appliquer(racine) {
		var liens = (racine || document).querySelectorAll('a[href]');
		for (var i = 0; i < liens.length; i++) {
			var a = liens[i];
			var url;
			try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { continue; }
			if (url.protocol !== 'http:' && url.protocol !== 'https:') continue;
			if (interne(url.host)) {
				/* Un lien du site s'ouvre normalement, même si un vieux
				   contenu lui avait posé un _blank en dur. */
				if (a.getAttribute('target') === '_blank') a.removeAttribute('target');
				continue;
			}
			a.setAttribute('target', '_blank');
			var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
			if (rel.indexOf('noopener') === -1) rel.push('noopener');
			a.setAttribute('rel', rel.join(' '));
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { appliquer(); });
	} else {
		appliquer();
	}
	/* L'éditeur et l'API Section Rendering re-rendent des sections entières. */
	document.addEventListener('shopify:section:load', function (event) { appliquer(event.target); });
})();

/* =============================================
   DÉFILEMENT SI DÉBORDEMENT — [data-mm-defile]
   ---------------------------------------------
   Générique : une boîte qui rogne (overflow hidden) et sa pièce mobile en
   premier enfant. Si le contenu déborde de la boîte, on pose .is-defile et
   deux variables que la CSS consomme : --mm-defile-dist (le débordement,
   en px) et --mm-defile-dur (durée proportionnelle à la distance, pour une
   vitesse de lecture constante d'une mention à l'autre). Si tout tient,
   rien ne bouge — le déclencheur est la mesure, jamais la largeur d'écran.
   Premier client : la mention de certification des cartes partenaires
   (assets/mm-partenaire-card.css, bloc .mm-part-card__badge).
   ============================================= */
(function () {
	function mesureDefile() {
		document.querySelectorAll('[data-mm-defile]').forEach(function (boite) {
			var piece = boite.firstElementChild;
			if (!piece) return;
			/* Mesure au repos : la classe retirée d'abord, sinon le transform
			   en vol fausse scrollWidth sur certains moteurs. */
			boite.classList.remove('is-defile');
			var style = getComputedStyle(boite);
			var fenetre = boite.clientWidth
				- parseFloat(style.paddingLeft)
				- parseFloat(style.paddingRight);
			var depassement = Math.ceil(piece.scrollWidth - fenetre);
			if (depassement > 1) {
				boite.style.setProperty('--mm-defile-dist', depassement + 'px');
				/* ~28px/s, plancher à 3s : les petits débordements ne filent
				   pas, les grands ne s'éternisent pas. */
				boite.style.setProperty('--mm-defile-dur', Math.max(3, depassement / 28).toFixed(2) + 's');
				boite.title = piece.textContent.trim();
				boite.classList.add('is-defile');
			} else {
				boite.style.removeProperty('--mm-defile-dist');
				boite.style.removeProperty('--mm-defile-dur');
				boite.removeAttribute('title');
			}
		});
	}

	var attente;
	window.addEventListener('resize', function () {
		clearTimeout(attente);
		attente = setTimeout(mesureDefile, 180);
	});
	/* Les fontes changent les largeurs : re-mesure quand elles arrivent. */
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(mesureDefile);
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', mesureDefile);
	} else {
		mesureDefile();
	}
	/* Éditeur de thème : les sections se re-rendent sans rechargement. */
	document.addEventListener('shopify:section:load', mesureDefile);
})();
